(function HotelEngineSearchResults($, Adzuki)
{
	"use strict";

	// only needed if we wanted to make some of this functionality accessible in other areas
	// var HotelEngineSearchResults = {};
	var map = null,
		applyFilters;

	$(document).ready(function documentReady()
	{
		Adzuki.onload('HotelEngine/searchResults', function onload()
		{
			// for the map
			var results_data_selector = '.hotel-search-results .map-view .map-container .hotels-map';

			var applyPropertyNameFilter = Adzuki.Debounce(function _applyPropertyNameFilter() {
				applyFilters();
			}, 700);


			var applyAmenityNameFilter = Adzuki.Debounce(function _applyPropertyNameFilter() {
				applyFilters();
			}, 700);

			var hotel_gallery,
				map,
				total_items       = 0,
				comparison_data   = null,
				comparison_cookie = Cookies.get('he_hotel_comparison_ids') || '';

			loadHotels();

			// prevent form from submitting when filtering
			$(window).keydown(function _preventFormSubmit(event) {
				if (event.keyCode === 13) {
					event.preventDefault();
					return false;
				}
			});

			// determines which price ranges should be checked on load
			autoCheckPriceRanges(
				parseInt($('.price-ranges-section').data('price-min')),
				parseInt($('.price-ranges-section').data('price-max'))
			);

			// property name filter
			$('#property-name').on('keyup', function propertyNameFilter() {
				applyPropertyNameFilter();
			});

			// property name cleared. Separated because we don't want the delay when clearing like on the "typeahead"
			$('#property-name').on('cleared', function propertyNameFilter() {
				applyFilters();
			});


			// property name filter
			$('#amenity-name').on('keyup', function propertyNameFilter() {
				applyAmenityNameFilter();
			});

			// property name cleared. Separated because we don't want the delay when clearing like on the "typeahead"
			$('#amenity-name').on('cleared', function propertyNameFilter() {
				applyFilters();
			});

			$('.clear-btn').on('click', function _clearPropertyName(e) {
				e.preventDefault();

				$('#property-name').val('').trigger('cleared');
			});

			$('.sort-by').on('change', function setSort() {
				applySort($(this));
			});

			$('.option-star-level').on('change', function changeChecks() {
				applyFilters();
			});

			$('.option-hotel-collection').on('change', function changeCollection() {
				applyFilters();
			});

			$(document).on("change", '.amenity-check', function amenityFilter() {
				applyFilters();
			});

			$('.option-price-range').on('change', function changePrices() {

				var range = getMinMaxPrice();

				if (range.min !== undefined) {
					autoCheckPriceRanges(range.min, range.max);
				}

				applyFilters();
			});

			$(document).on("change", '.option-specialty-rate', function specialtyFilter() {
				applyFilters();
			});

			// "See all from ..." link should check the hotel program in left nav, apply filters and reload search results
			$(document).on("click", '.specialty-see-all', function specialtySeeAll(e) {
				var $self     = $(this),
				    rate_code = $self.data('rate-code');

				e.preventDefault();

				// will uncheck all other specialty rates and only check the clicked one from featured properties
				$('.option-specialty-rate').each(function _iterateSpecialty() {
					var $checkbox = $(this);

					$checkbox.prop('checked', false);

					if ($checkbox.attr('value') === rate_code) {
						$checkbox.prop('checked', true);
					}
				});

				applyFilters();
			});

			$('.featured-collection-filter').on('click', function filterCollectionLink(e) {
				var val = $(this).attr('data-collection');

				e.preventDefault();

				$('.option-hotel-collection').each(function checkCollection() {
					$(this).prop('checked', false);

					if ($(this).val() === val) {
						$(this).prop('checked', true);
					}
				});
				applyFilters();
			});

			// more or less amenities displayed
			$('.show-amenities-toggle').click(function showAmenities(e) {
				e.preventDefault();
				toggleMoreAmenities($(this));
			});

			// clear all checks for a filter type
			$('.reset-all a').click(function removeChecks(e) {
				e.preventDefault();
				clearAllForFilterType($(this));
			});

			// while ajax pagination loading, overlay on filters so user does not click on em
			$(".ajax-pagination").on("click", ".pagination .ajax", function ajaxPage(e) {
				toggleFilterOverlay(true);
			});

			// after ajax pagination finished loading, remove overlay over filters
			$('body').on('ajax-pagination.loaded', function ajaxPagination() {
				toggleFilterOverlay(false);
				initPopovers();
			});

			// image gallery thing
			$('.hotel-search-results, .hotel-engine-featured').on('click', '.hotel-image', function _onGalleryClick() {
				var featured = 0;

				if ($(this).data('featured')) {
					featured = $(this).data('featured');
				}

				Adzuki.Ajax.post('/HotelEngine/getGalleryImages/' + $(this).data('giata-id') + '/' + featured)
				.then(function sucess(response) {
					var images         = response;
					var gallery_images = [];

					if (images.length === 0) {
						return;
					}

					$.each(images, function onEachImage(i, image) {
						gallery_images.push({
							src    : image.src,
							thumb  : image.thumb,
							subHtml: image.subHtml,
						});
					});

					hotel_gallery = lightGallery($('.hotel-image')[0], {
						licenseKey       : 'github',
						download         : false,
						plugins          : [lgThumbnail],
						dynamic          : true,
						thumbnail        : true,
						toggleThumb      : true,
						allowMediaOverlap: true,
						dynamicEl        : gallery_images,
					});

					hotel_gallery.openGallery();
				});
			});

			$('.hotel-search-results').on('click', '.filter-chip', function _removeFilterFromResult() {
				var type  = $(this).data('type'),
					value = $(this).data('value');

				switch (type) {
					case 'star-rating':
						$('.option-star-level').each(function _iterateStars() {
							if (parseInt($(this).val()) === parseInt(value)) {
								$(this).trigger('click');
							}
						});
					break;
					case 'price':
						$('.option-price-range').each(function _iterateAmenities() {
							if (parseInt($(this).val()) === parseInt(value)) {
								$(this).trigger('click');
							}
						});
					break;
					case 'amenity':
						$('.amenity-check').each(function _iterateAmenities() {
							if (parseInt($(this).val()) === parseInt(value)) {
								$(this).trigger('click');
							}
						});
					break;
					case 'specialty_rate':
						$('.option-specialty-rate').each(function _iterateSpecialty() {
							if ($(this).val() === value) {
								$(this).trigger('click');
							}
						});
					break;

					default:
						console.log("nadda");
					break;
				}
			});

			$('.map-button').click(function _disableClick(e) {
				e.preventDefault();
			});

			$('.map-background').click(function toggleMap() {
				if ($('.map-view').hasClass('hidden')) {
					$('.map-view').removeClass('hidden');
					map = new Adzuki.Map(
						$('.hotel-search-results').find('.hotels-map'), {
							zoom: 10,
							init: function map_init(_map) {
								_map.populate($(results_data_selector).data('map-markers'));
							}
						}
					);

					map.markerClickCallback     = highlightActiveMarkerListing;
					map.infoWindowCloseCallback = unhighlightActiveMarkerListing;

					$('.map-button').html('Hide Map');
				} else {
					$('.map-view ').addClass('hidden');
					$('.map-button').html('Show Map');

					$('.map-view-active').removeClass('map-view-active');
				}
			});

			$('.hotel-search-results').on('click', '.hotel-engine-poi', function _hotelPoi(e) {
				var $modal = $('.modal'),
					marker = $(this).data('marker');

				e.preventDefault();

				$(".modal-dialog").addClass('modal-lg');

				marker = btoa(marker);

				Adzuki.Ajax.get('/HotelEngine/poi/' + marker).then(function _showPointsOfInterest(content) {
					$modal.find('.modal-title').text("Points of Interest");
					$modal.find('.modal-body').html(content);

					map = new Adzuki.Map(
						$('#poi-map'), {
							zoom: 15,
							init: function map_init(_map) {
								_map.populate($('#poi-map').data('main-marker'));
							}
						}
					);

					$modal.on('hidden.bs.modal', function _restoreModal() {
						$modal.removeClass('wide').off('hidden.bs.modal');
					}).modal('show');
				});
			});

			$('.modal').on('click', '.poi-category', function _addPois(e) {
				var markers = $(this).data('markers'),
					that    = $(this);

				map = new Adzuki.Map(
					$('#poi-map'), {
						zoom: 15,
						init: function map_init(_map) {
							_map.populate($('#poi-map').data('main-marker'));
						}
					}
				);

				markers.forEach(function _plotPOICategoryLocationMarker(marker) {
					if (that.prop('checked') === true) {
						marker.icon = 'https://maps.google.com/mapfiles/kml/paddle/red-stars-lv.png';
						map._createMarker(marker);
					} else {
						console.log("destroy");
						console.log(marker);
						map._destroyMarker(marker);
					}
				});

				map.viewAllMarkers();

				if (map.mapMarkers.length === 1) {
					map.map.setZoom(15);
				}
			});


			$('.hotel-search-results').on('click', '.result .view-on-map', function triggerMarker(e) {
				var $self           = $(this),
					viewResultOnMap;

				viewResultOnMap = function _viewResultOnMap() {
					var marker = map.mapMarkers[$self.data('index')];
					google.maps.event.trigger(marker, 'click');
					map.map.setZoom(16);
					map.map.setCenter(
						new google.maps.LatLng(marker.lat, marker.lng)
					);

					$("html, body").animate(
						{ scrollTop: 0 },
						"fast"
					);
				};

				e.preventDefault();

				if ($('.map-view ').hasClass('hidden')) {
					$('.map-background').click();

					setTimeout(function _showAndClick() {
						viewResultOnMap();
					}, 500);
				} else {
					viewResultOnMap();
				}
			});

			// comparison stuff
			$('.hotel-search-results, .hotel-engine-featured').on('click', '.result .he-hotel-comparison', function _hotelComparisonClick(e) {
				var max_hotels        = 6,
					json_data         = {};

				if (comparison_data === null) {
					if (comparison_cookie !== '') { // eslint-disable-line no-negated-condition
						comparison_data = JSON.parse(comparison_cookie);
					} else {
						comparison_data = {};
					}
				}

				json_data['name']           = $(this).data('name');
				// json_data['description']    = $(this).data('description');
				json_data['giata_id']       = $(this).data('giata-id');
				json_data['image']          = $(this).data('image');
				json_data['total_stay']     = $(this).data('total-stay');
				json_data['original_price'] = $(this).data('original-price');
				json_data['address']        = $(this).data('address');
				json_data['star_rating']    = $(this).data('star-rating');
				json_data['check_in']       = $(this).data('check-in');
				json_data['check_out']      = $(this).data('check-out');

				if ($(this).prop('checked') === true) {
					comparison_data[$(this).data('giata-id')] = json_data;
					total_items                               = countObjectItems(comparison_data);

					if (total_items > max_hotels) {
						Adzuki.StatusMessage(null, 'You can only compare up to ' + max_hotels + ' hotels at a time', 'Max reached');

						delete comparison_data[$(this).data('giata-id')];
						$(this).prop('checked', false);
						total_items--;
					}
				} else {
					delete comparison_data[$(this).data('giata-id')];
					total_items = countObjectItems(comparison_data);
				}

				Cookies.set('he_hotel_comparison_ids', JSON.stringify(comparison_data), {
					expires: 7,
					path   : '/'
				});

				if (total_items > 0) {
					showComparisonWidget(total_items);
				} else {
					hideComparisonWidget();
				}
			});

			$('.he-hotel-comparison-container').on('click', '.he-comparison-remove', function _removeFromComparison(e) {
				e.preventDefault();

				delete comparison_data[$(this).data('giata-id')];
				total_items = countObjectItems(comparison_data);

				$('.he-hotel-comparison[data-giata-id="' + $(this).data('giata-id') + '"]').prop('checked', false);

				Cookies.set('he_hotel_comparison_ids', JSON.stringify(comparison_data), {
					expires: 7,
					path   : '/'
				});

				if (total_items > 0) {
					showComparisonWidget(total_items);
				} else {
					hideComparisonWidget();
				}
			});

			$('.he-hotel-comparison-container').on('click', '.he-comparison-remove-all', function _removeAllFromComparison(e) {
				e.preventDefault();
				Adzuki.CustomConfirm({
					title  : 'Decision Time',
					content: 'Are you sure you want to remove all?',
					confirm: function confirm() {
						Cookies.remove('he_hotel_comparison_ids');
						comparison_data   = null;
						total_items       = 0;
						comparison_cookie = '';

						$('.he-hotel-comparison').each(function uncheckAll() {
							$(this).prop('checked', false);
						});

						hideComparisonWidget();
					}
				});
			});

			$('.he-hotel-comparison-container').on('click', '.he-comparison-send', function _sendComparison(e) {
				e.preventDefault();

				total_items = countObjectItems(comparison_data);

				if (total_items > 1) {
					document.location = Adzuki.base_uri + '/HotelEngine/comparison/';
				} else {
					Adzuki.StatusMessage('error', 'You cannot send a comparison with only 1 hotel selected. Please have at least 2 selected in order to continue.');
				}
			});

			$('.he-hotel-comparison-container').on('click', '.comparison-filter', function comparisonFilterClicked() {
				if ($(this).hasClass(Adzuki.FaIcon.getIconStyle('collapse', 'regular'))) {
					$('.he-hotel-comparison-row').addClass('hidden');

					$(this).removeClass(Adzuki.FaIcon.getIconStyle('collapse', 'regular'));
					$(this).addClass(Adzuki.FaIcon.getIconStyle('expand', 'regular'));
					$(this).data("expanded", "0");
				} else {
					$('.he-hotel-comparison-row').removeClass('hidden');

					$(this).removeClass(Adzuki.FaIcon.getIconStyle('expand', 'regular'));
					$(this).addClass(Adzuki.FaIcon.getIconStyle('collapse', 'regular'));
					$(this).data("expanded", "1");
				}
			});

			// show onload
			if (comparison_cookie !== '') { // eslint-disable-line no-negated-condition
				comparison_data = JSON.parse(comparison_cookie);
				total_items     = countObjectItems(comparison_data);

				if (total_items > 0) {
					showComparisonWidget(total_items);
				}
			} else {
				hideComparisonWidget();
			}

			// back/forward buttons clicked in browser
			window.addEventListener('popstate', function browserButton(event) {
				loadHotels();
			}, false);
		});
	});

	// apply any filters to data set server-side
	applyFilters = Adzuki.Debounce(function applyFilters()
	{
		var post_url = '/HotelEngine/setSearchFilters',
		    filters  = {
				amenity_name   : $('#amenity-name').val(),
		        property_name  : $('#property-name').val(),
		        star_ratings   : getCheckedVals('.option-star-level'),
		        amenity_ids    : getCheckedVals('.amenity-check'),
		        specialty_rates: getCheckedVals('.option-specialty-rate'),
				collections    : getCheckedVals('.option-hotel-collection')
		    },
		    price_range = getMinMaxPrice();

		// overlay filters so user does not click while loading hotels
		toggleFilterOverlay(true);

		// re-use AjaxPagination loading UI so it's consistent
		Adzuki.AjaxPagination.defaultLoading($('.hotel-search-results'));

		if (price_range.min !== undefined) {
			filters.nightly_price_range = {
				start: price_range.min,
				end  : price_range.max
			};
		}
		console.log(post_url, 'Post Url');
		console.log(filters, 'Filters');

		if (typeof filters['star_ratings'] !== 'undefined') {
			toggleStarCounts(filters['star_ratings']);
		}

		Adzuki.Ajax.post(post_url, filters).
		then(function success(response) {

			if (response.filters_set === false) {
				if (response.redirect === true) {
					window.location.href = Adzuki.base_uri + '/HotelEngine';
					return;
				}

				toggleFilterOverlay(false);
				Adzuki.StatusMessage('error', 'Error setting filters');

				return;
			}

			loadHotels(true);
		});
	}, 750);

	// apply sort to data set server-side
	function applySort($input)
	{
		toggleFilterOverlay(true);

		Adzuki.Ajax.get('/HotelEngine/setSort/' + $input.val())
		.then(function success(data) {
			loadHotels(true);
		});
	}

	// handle any price blocks in the middle of other checked blocks.  these should be disabled to indicate you have to accept it
	// since you have their outer blocks checked
	function autoCheckPriceRanges(min, max)
	{
		if (max === 0) {
			return;
		}

		$('.option-price-range').each(function forSlider(i) {
			var $self     = $(this),
			    split     = $self.val().split("-"),
			    block_min = parseInt(split[0]),
			    block_max = parseInt(split[1]);

			// if the checkbox range is entirely within the values, check the box and disable
			if ( (block_min > min) && (block_max < max) ) {
				$self.prop('checked', true);
				$self.prop('disabled', true);
			} else {
				$self.prop('disabled', false);

				if (block_min === min) {
					$self.prop('checked', true);
				}

				if (block_max === max) {
					$self.prop('checked', true);
				}
			}
		});
	}

	// clear all star rating, price range, amenities checkboxes.  the link must have data-checkbox-class which is a class applied to all checkboxes of that filter type
	function clearAllForFilterType($element)
	{
		var check_class = '.' + $element.data('checkbox-class');

		$(check_class).prop('checked', false);

		// trigger change for first checkbox to set off ajax filtering
		$(check_class).eq(0).trigger("change");
	}

	// return only the values of checked checkboxes with a certain css class or possibly other selector
	function getCheckedVals(selector)
	{
		var vals = [];

		$(selector + ':checked').each(function checkedVals() {
			vals.push($(this).val());
		});

		return vals;
	}

	// pull in hotel content via ajax and place on page
	function loadHotels(reset_page) {
		var $sr_container = $('.hotel-search-results'),
		    ajax_url      = '/HotelEngine/displaySearchResults',
		    page_num_hash = Adzuki.AjaxPagination.getPageNumberHash();

		// we may want to force reset to page 1. for example if the user is changing the sort order
		if (reset_page === true) {
			ajax_url += '/#page_num:1';
			Adzuki.AjaxPagination.adjustBrowserHistory(ajax_url);

		} else if (page_num_hash.length > 0) {
			ajax_url += '/' + page_num_hash;
		}

		// re-use AjaxPagination loading UI so it's consistent
		Adzuki.AjaxPagination.defaultLoading($sr_container);

		Adzuki.Ajax.get(ajax_url)
		.then(function success(data) {
			$sr_container.html(data);

			reloadAmenities();

			// remove overlay over filters
			toggleFilterOverlay(false);

			Adzuki.AjaxPagination.defaultLoadingEnd($sr_container);
			Adzuki.AjaxPagination.scrollUp();

			// after initial page load, set this data attribute so AjaxPagination.scrollUp() will know to scroll to a specific element rather than to top of page
			$('.ajax-pagination').data("scroll-to-element-id", 'hotel-engine-box');

			initSpecialtyBadges();
			initPopovers();
		})
		.catch(function contentError(data) {
			toggleFilterOverlay(false);

			$sr_container.html('Error loading hotel content: ' + ajax_url);

			Adzuki.AjaxPagination.defaultLoadingEnd($sr_container);
		});
	}

	// get the min and max prices checked
	function getMinMaxPrice()
	{
		var output = {};

		// get the min and max checked
		$('.option-price-range:checked').each(function innerBlocks(i) {
			var $self     = $(this),
			    split     = $self.val().split("-"),
			    block_min = parseInt(split[0]),
			    block_max = parseInt(split[1]);

			if (i === 0) {
				output.min = block_min;
			}

			output.max = block_max;
		});

		return output;
	}

	function initSpecialtyBadges()
	{
		var $modal = $('.modal');

		$('.specialty-badge').on('click', function click(e) {
			$modal.find('.modal-title').text('SPECIALTY RATE PROGRAM');
			$modal.find('.modal-body').html('<span class="'+Adzuki.FaIcon.getIconStyle('spinner')+' fa-2x fa-spin"></span> Retrieving specialty rate information...');
			$modal.modal('show');

			Adzuki.Ajax.get('/HotelEngine/loadSpecialtyRateDetails/' + encodeURIComponent($(this).data('sabre-hotel-id')) + '/' + encodeURIComponent($(this).data('rate-code')))
			.then(function content(content) {
				$modal.find('.modal-body').html(content);
			});
		});
	}

	// ajax in amenities, which will determine if any checkboxes should be disabled (ie. none of the current result set offer that amenity)
	function reloadAmenities()
	{
		var show_all = 0,
		    $element = $('#amenities-container');

		// user is currently showing more than the top X amenities, so keep it like that
		if (parseInt($('.show-amenities-toggle').data('expanded')) === 1) {
			show_all = 1;
		}

		Adzuki.Ajax.get('/HotelEngine/getAmenities/' + show_all)
		.then(function success(data) {
			$element.html(data);

			// should we show clear alls for the various checkbox filter types?
			toggleClearAlls();
		})
		.catch(function contentError(data) {
			$element.html('<div class="alert-danger">Error loading amenities</div>');
		});
	}

	// "clear alls" for various filters that are checkboxes
	function toggleClearAlls()
	{
		var $resets = $('.reset-all');

		$resets.each( function toggleClearAll(i) {
			var $self          = $(this),
			    $link          = $self.find('a'),
			    checkbox_class = '.' + $link.data('checkbox-class'),
			    add_class      = true;                              // assume the "clear all" remains hidden

			// at least one is checked, so show "clear all"
			if ($(checkbox_class + ':checked').length > 0) {
				add_class = false;
			}

			$self.toggleClass('hidden', add_class);
		});
	}

	// gray out the filter inputs while center content loading. necessary so user does not click before page finishes loading
	// probably more of an issue on dev when the debug toolbar is being used
	function toggleFilterOverlay(turn_on)
	{
		$('#he-filters-container').toggleClass('overlay', turn_on);
		$('.hotel-engine-featured').toggleClass('overlay', turn_on);
		$('.map-view ').addClass('hidden');
		$('.map-button').html('Show Map');
	}

	// increase or decrease the list of amenities displaying
	function toggleMoreAmenities($link)
	{
		var text     = $link.data('alt-text'),
		    expanded = parseInt($link.data('expanded')),
		    opposite = (expanded === 0) ? 1 : 0;

		$('.side-amenity-list').toggleClass('hidden');
		$link.data('alt-text', $link.html());
		$link.html(text);

		$link.data('expanded', opposite);
	}

	// show or hide counts next to star ratings. if any filters applied, hide. if not, show
	function toggleStarCounts(filters)
	{
		var hide_counts = false;

		$.each( filters, function iter( index, value ) {
			if (value.length > 0) {
				hide_counts = true;
				return;
			}

			if ($.isEmptyObject(value) === false) {
				hide_counts = true;
				return;
			}
		});

		$('.star-counts').toggleClass('hidden', hide_counts);
	}

	function highlightActiveMarkerListing(marker)
	{
		$('.hotel-search-results.result.map-view-active').removeClass('map-view-active');
		$('.hotel-search-results.result[data-giata-id="' + marker.giata_id + '"]').addClass('map-view-active');
	}

	function unhighlightActiveMarkerListing(marker) {
		$('.hotel-search-results.result.map-view-active').removeClass('map-view-active');
		map.viewAllMarkers();
	}

	function countObjectItems(obj) {
		var count = 0;

		$.each(obj, function qaParseShips(key, value) {
			count++;
		});

		return count;
	}

	function showComparisonWidget(total_items) {
		$('.he-hotel-comparison-container').removeClass('hidden');
		// $('.he-hotel-comparison').html('<i class="' + Adzuki.FaIcon.getIconStyle('spinner') + ' fa-spin fa-2x"></i>&nbsp;Loading properties...');

		Adzuki.Ajax.get('/HotelEngine/comparisonWidget/')
		.then(function success(response) {
			var expanded = $('.comparison-filter').data("expanded");

			if (expanded === 0) {
				$('.comparison-filter').trigger('click');
			}

			$('.hotel-comparison-count').html(total_items);
			$('.he-hotel-comparison').html(response);
		});
	}

	function hideComparisonWidget() {
		$('.he-hotel-comparison-container').addClass('hidden');
		$('.he-hotel-comparison').html('');
	}

	function initPopovers() {
		let $otaBox =  $('.verified-box');
		if ($otaBox.length) {
			$($otaBox).popover(
				{
					placement: dynamicPlacement,
				}
			);
		} else {
			console.error("Verified box element is missing in the DOM.");
		}
	}

	function dynamicPlacement(popover, triggerElement) {
		const screenWidth = window.innerWidth;

		if (screenWidth < 500) {
			return 'top';
		} else if (screenWidth < 768) {
			return 'right';
		}

		return 'left';

	}

	// Adzuki.HotelEngineSearchResults = HotelEngineSearchResults;

}(jQuery, window.Adzuki || {}));
